import { db } from '../firebase/firebaseConfig';
import { ref, push, set, remove } from 'firebase/database';
import { NOTIFICATION_TEMPLATES } from '../data/notificationTemplates';

/**
 * Creates a new notification in the database.
 * Supports both (uid, title, message, type, expiry) AND (uid, {title, message, type, expiryHours})
 */
export const createNotification = async (uid, arg2, arg3, arg4 = 'info', arg5 = 24) => {
  try {
    let title, message, type, expiryHours;

    if (typeof arg2 === 'object' && arg2 !== null) {
      ({ title, message, type = 'info', expiryHours = 24 } = arg2);
    } else {
      title = arg2;
      message = arg3;
      type = arg4;
      expiryHours = arg5;
    }

    const notifRef = ref(db, 'notifications');
    const newNotifRef = push(notifRef);
    const createdAt = Date.now();
    const expiresAt = createdAt + (expiryHours * 60 * 60 * 1000);

    await set(newNotifRef, {
      notificationId: newNotifRef.key,
      title,
      message,
      target: uid,
      type,
      createdAt,
      expiresAt
    });
    return newNotifRef.key;
  } catch (error) {
    console.error("Error creating notification:", error);
    return null;
  }
};

/**
 * Convenience method to send a predefined template notification.
 */
export const sendTemplateNotification = async (uid, templateKey, customExpiry = 24) => {
  const template = NOTIFICATION_TEMPLATES[templateKey];
  if (!template) {
    console.warn(`Notification template "${templateKey}" not found.`);
    return null;
  }
  return await createNotification(uid, template.title, template.message, template.type, customExpiry);
};

/**
 * Deletes/Dismisses a notification from the database.
 */
export const deleteNotification = async (notificationId) => {
  try {
    const notifRef = ref(db, `notifications/${notificationId}`);
    await remove(notifRef);
    return true;
  } catch (error) {
    console.error("Error deleting notification:", error);
    return false;
  }
};
